module.exports = __webpack_public_path__ + "img/casa.7b3afc9a.png";